import { useState, useRef } from 'react';
import logoImg from '../../../assets/logo.png';

const CLIENT_STORAGE_KEY = 'LathiNyx_clients_v2';
function loadSavedClients() {
  try { return JSON.parse(localStorage.getItem(CLIENT_STORAGE_KEY)) || []; } catch { return []; }
}

const BRAND = {
  name: 'LathiNyx DevLabs', person: 'Aryan',
  email: 'lathinyxdevlabs@gmail.com',
  website: 'https://lathinyxdevlabs.com', address: 'Patna, Bihar, India',
};

const SERVICE_TYPES = ['Web Development', 'AI & ML Solutions', 'Research & Academic Writing', 'UI/UX Design', 'SEO & Digital Marketing', 'Mobile App Development', 'Data Analysis', 'Consulting', 'Other'];

const docs = [
  { type: 'contract', icon: '◈', iconClass: 'contract', title: 'Client Project Proposal', sub: 'Comprehensive professional agreement between LathiNyx DevLabs and client', covers: 'Scope · Deliverables · Payment · Revisions · IP · Confidentiality · Termination' },
  { type: 'project', icon: '◉', iconClass: 'project', title: 'Project Brief & Scope', sub: 'Detailed project documentation with requirements and milestones', covers: 'Overview · Requirements · Timeline · Milestones · Acceptance criteria' },
  { type: 'confidential', icon: '▣', iconClass: 'nda', title: 'Confidentiality Agreement', sub: 'Mutual confidentiality to protect sensitive project information', covers: 'Confidential info · Obligations · Duration 2 years' },
  { type: 'onboarding', icon: '▷', iconClass: 'project', title: 'Client Onboarding Document', sub: 'Welcome packet with process and communication guidelines', covers: 'Welcome · Process flow · SLA · Revision policy · Payment milestones' },
  { type: 'proposal', icon: '◆', iconClass: 'contract', title: 'Service Proposal / Quote', sub: 'Formal proposal with pricing, timeline and approach', covers: 'Executive summary · Solution · Pricing · Timeline · Next steps' },
  { type: 'testimonial', icon: '◇', iconClass: 'project', title: 'Testimonial Request Form', sub: 'Request a testimonial from your client after project completion', covers: 'Project summary · Feedback request · Rating · Permission to publish' },
  { type: 'retainer', icon: '▶', iconClass: 'contract', title: 'Retainer Agreement', sub: 'Monthly retainer contract for ongoing services', covers: 'Monthly scope · Hours · Rate · Billing cycle · Termination' },
];

const defaultForm = {
  clientName: '', clientCompany: '', clientEmail: '', clientCity: '',
  serviceType: 'Web Development',
  projectName: '', projectDesc: '', projectValue: '', paymentTerms: '50% advance, 50% on delivery',
  revisions: '3 free revision rounds', startDate: '', endDate: '',
  item1: 'Web Design & Development', qty1: '1', rate1: '40000',
  item2: 'SEO & Mobile Optimization', qty2: '1', rate2: '8000',
  discount: '10', invoiceNum: 'INV-2026-041', dueDate: '',
};

const PDF_CSS =
  'body{font-family:Arial,Helvetica,sans-serif;padding:0;max-width:820px;margin:auto;color:#1a1a2e;font-size:11.5px;line-height:1.5}' +
  '.header{background:#1a2744;color:#fff;padding:22px 32px 18px;display:flex;justify-content:space-between;align-items:flex-start}' +
  '.header-left{display:flex;align-items:center;gap:14px}' +
  '.header-logo{height:100px;width:160px;object-fit:contain;border-radius:8px;background:#fff;padding:8px;border:2px solid rgba(255,255,255,0.4);display:block}' +
  '.header-brand{font-size:15px;font-weight:800;color:#fff;letter-spacing:0.5px;line-height:1.2}' +
  '.header-sub{font-size:10px;color:rgba(255,255,255,0.65);margin-top:2px}' +
  '.header-doc-type{font-size:10px;color:rgba(255,255,255,0.5);margin-top:4px;letter-spacing:1px;text-transform:uppercase}' +
  '.header-right{text-align:right;font-size:10px;color:rgba(255,255,255,0.7);line-height:1.8}' +
  '.header-right b{color:#fff}' +
  '.title-band{background:#243560;padding:20px 32px 22px;color:#fff}' +
  '.title-band h1{font-size:22px;font-weight:900;letter-spacing:2px;text-transform:uppercase;margin:0 0 4px;color:#fff}' +
  '.title-band .doc-sub{font-size:11px;color:rgba(255,255,255,0.6);margin-bottom:10px}' +
  '.title-band .meta-row{display:flex;gap:32px;flex-wrap:wrap;margin-top:10px}' +
  '.title-band .meta-item{font-size:10px;color:rgba(255,255,255,0.55);text-transform:uppercase;letter-spacing:0.5px}' +
  '.title-band .meta-item b{display:block;font-size:12px;color:#fff;font-weight:700;margin-top:1px;text-transform:none;letter-spacing:0}' +
  '.body{padding:24px 32px}' +
  '.sec{margin-bottom:18px;page-break-inside:avoid}' +
  '.sec-title{font-size:11px;font-weight:800;color:#1a2744;text-transform:uppercase;letter-spacing:1.2px;border-bottom:2px solid #1a2744;padding-bottom:4px;margin-bottom:10px}' +
  '.sec-num{display:inline-block;background:#1a2744;color:#fff;font-size:10px;font-weight:800;padding:1px 7px;border-radius:2px;margin-right:6px;letter-spacing:0.5px}' +
  'p{font-size:11.5px;line-height:1.6;margin-bottom:5px;color:#1a1a2e}' +
  'ul{margin:6px 0 6px 18px;padding:0}' +
  'li{font-size:11.5px;line-height:1.6;color:#1a1a2e;margin-bottom:3px}' +
  'table{width:100%;border-collapse:collapse;font-size:11px;margin-top:6px;page-break-inside:avoid}' +
  'td,th{padding:7px 10px;border:1px solid #d0d7e8}' +
  'th{background:#1a2744;color:#fff;font-weight:700;font-size:10px;text-transform:uppercase;letter-spacing:0.5px}' +
  'tr:nth-child(even) td{background:#f4f6fb}' +
  '.highlight{color:#c0392b;font-weight:700}' +
  '.info-box{background:#f0f3fa;border-left:3px solid #1a2744;padding:10px 14px;margin:10px 0;font-size:11px;font-style:italic;color:#333;border-radius:0 4px 4px 0}' +
  '.sig{margin-top:24px;display:grid;grid-template-columns:1fr 1fr;gap:32px;page-break-inside:avoid}' +
  '.sig-line{border-top:2px solid #1a2744;padding-top:8px}' +
  '.sig-name{font-weight:800;font-size:12px;color:#1a2744;margin-bottom:1px}' +
  '.sig-role{color:#c0392b;font-weight:700;font-size:10px;margin-bottom:1px;text-transform:uppercase;letter-spacing:0.5px}' +
  '.sig-company{color:#555;font-size:10px}' +
  '.sig-img{max-height:40px;max-width:150px;object-fit:contain;display:block;margin-bottom:6px}' +
  'footer{margin-top:20px;padding:10px 32px;background:#1a2744;display:flex;justify-content:space-between;font-size:9.5px;color:rgba(255,255,255,0.6)}' +
  'footer b{color:#fff}' +
  '@media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact}}';

function f(v, fb) { return v && v.trim() ? v : (fb || '___________'); }
function fv(v) { return v ? 'Rs.' + parseInt(v).toLocaleString('en-IN') : 'Rs.___________'; }
function fm(n) { return 'Rs.' + Math.round(n).toLocaleString('en-IN'); }

function buildHeader(docType, docTitle, ref, date, logo, cn, cc, extra) {
  var logoHtml = logo ? '<img src="' + logo + '" class="header-logo" alt="Logo" />' : '';
  var extraHtml = extra || '';
  return '<div class="header">' +
    '<div class="header-left">' + logoHtml +
    '<div><div class="header-brand">' + BRAND.name + '™</div>' +
    '<div class="header-sub">' + BRAND.email + ' &nbsp;·&nbsp; ' + BRAND.website + '</div>' +
    '<div class="header-doc-type">' + docType + '</div></div></div>' +
    '<div class="header-right">Ref: <b>' + ref + '</b><br/>Date: <b>' + date + '</b>' + extraHtml + '</div>' +
    '</div>' +
    '<div class="title-band"><h1>' + docTitle + '</h1>' +
    '<div class="doc-sub">' + BRAND.name + ' &nbsp;·&nbsp; ' + BRAND.address + '</div>' +
    '<div class="meta-row">' +
    '<div class="meta-item">Prepared For<b>' + cn + (cc && cc !== '___________' ? ' · ' + cc : '') + '</b></div>' +
    '<div class="meta-item">Prepared By<b>' + BRAND.person + ' · ' + BRAND.name + '</b></div>' +
    '</div></div>' +
    '<div class="body">';
}

function buildSig(cn, cc, sig) {
  var ps = sig ? '<img src="' + sig + '" class="sig-img" alt="Signature" />' : '<div style="height:40px"></div>';
  return '</div><div style="padding:0 32px 24px"><div class="sig">' +
    '<div class="sig-line">' + ps + '<div class="sig-name">' + BRAND.person + '</div><div class="sig-role">Founder</div><div class="sig-company">' + BRAND.name + '™</div><div style="margin-top:6px;font-size:10px;color:#555">Date: ___________________</div></div>' +
    '<div class="sig-line"><div style="height:40px"></div><div class="sig-name">' + cn + '</div><div class="sig-company">' + cc + '</div><div style="margin-top:6px;font-size:10px;color:#555">Date: ___________________</div></div>' +
    '</div></div>';
}

function sec(title, content) {
  return '<div class="sec"><div class="sec-title">' + title + '</div>' + content + '</div>';
}

function termBlock(num, title, body) {
  return '<p><span class="sec-num">' + num + '</span><b>' + title + ':</b> ' + body + '</p>';
}

function buildBody(type, fd, ref, date, sig, logo) {
  var cn = f(fd.clientName, 'Client Name'), cc = f(fd.clientCompany, 'Company');
  var ce = f(fd.clientEmail, 'client@email.com'), pn = f(fd.projectName, 'Project Name');
  var pd = f(fd.projectDesc, 'As mutually agreed'), pv = fv(fd.projectValue);
  var pt = f(fd.paymentTerms, '50% advance, 50% on delivery'), rv = f(fd.revisions, '3 free revision rounds');
  var sd = f(fd.startDate), ed = f(fd.endDate), s = buildSig(cn, cc, sig);
  var svc = f(fd.serviceType, 'Professional Services');

  if (type === 'contract') return buildHeader(svc, 'CLIENT PROJECT\nPROPOSAL', ref, date, logo, cn, cc) +
    sec('1. Parties to this Agreement',
      '<table><tr><th>Role</th><th>Full Name</th><th>Organization</th><th>Contact</th></tr>' +
      '<tr><td><b>Service Provider</b></td><td>' + BRAND.person + '</td><td>' + BRAND.name + '™</td><td>' + BRAND.email + '</td></tr>' +
      '<tr><td><b>Client</b></td><td>' + cn + '</td><td>' + cc + '</td><td>' + ce + '</td></tr></table>') +
    sec('2. Scope of Services',
      '<table>' +
      '<tr><td width="34%"><b>Service Type</b></td><td>' + svc + '</td></tr>' +
      '<tr><td><b>Project Title</b></td><td>' + pn + '</td></tr>' +
      '<tr><td><b>Description</b></td><td>' + pd + '</td></tr>' +
      '<tr><td><b>Total Contract Value</b></td><td><span class="highlight">' + pv + '</span></td></tr>' +
      '<tr><td><b>Payment Schedule</b></td><td>' + pt + '</td></tr>' +
      '<tr><td><b>Revision Policy</b></td><td>' + rv + '</td></tr>' +
      '<tr><td><b>Project Timeline</b></td><td>' + sd + ' &nbsp;→&nbsp; ' + ed + '</td></tr>' +
      '<tr><td><b>Intellectual Property</b></td><td>Full IP rights transfer to Client upon receipt of final payment</td></tr>' +
      '<tr><td><b>Post-Delivery Support</b></td><td>7–14 days free support after final delivery</td></tr></table>') +
    sec('3. Proposed Solution & Approach',
      '<p>' + BRAND.name + ' follows a structured delivery methodology ensuring transparency, regular deliverables, and flexibility to adapt to changing requirements. Key elements of our approach:</p>' +
      '<ul><li><b>Discovery-first:</b> We invest time understanding your business before writing a single line of code.</li>' +
      '<li><b>Milestone-based delivery:</b> Regular progress updates so you see results at every phase.</li>' +
      '<li><b>Quality-first:</b> Dedicated review at every phase, not just at the end.</li>' +
      '<li><b>Post-launch support:</b> We do not disappear after go-live — ' + rv + ' included.</li></ul>') +
    sec('4. Terms & Conditions',
      termBlock('4.1', 'Payment', 'The Client agrees to pay <span class="highlight">' + pv + '</span> as per the schedule: <b>' + pt + '</b>. Late payments attract a fee of <b>2% per month</b> on the outstanding amount. Work may be paused if payment is overdue by more than 7 days.') +
      termBlock('4.2', 'Scope of Work', 'The Service Provider will deliver only the services described above. Any additional work outside the agreed scope will be billed separately as a change request, with prior written approval.') +
      termBlock('4.3', 'Revisions', 'This agreement includes <b>' + rv + '</b> at no extra charge. Additional revisions beyond the included rounds will be billed at the standard hourly rate.') +
      termBlock('4.4', 'Intellectual Property', 'All IP rights transfer to the Client upon receipt of full payment. Until then, all work remains the property of <b>' + BRAND.name + '</b>.') +
      termBlock('4.5', 'Confidentiality', 'Both parties agree to keep all shared information strictly confidential. This obligation survives termination for <b>2 years</b>.') +
      termBlock('4.6', 'Termination', 'Either party may terminate this agreement with <b>7 days written notice</b>. All completed work up to termination shall be invoiced and paid in full.') +
      termBlock('4.7', 'Limitation of Liability', 'The Service Provider\'s total liability shall not exceed the total contract value. Neither party is liable for indirect or consequential damages.') +
      termBlock('4.8', 'Governing Law', 'This agreement shall be governed by the laws of India. Any disputes shall be resolved through mutual negotiation, failing which through arbitration in Patna, Bihar.')) +
    s;

  if (type === 'project') return buildHeader(svc, 'PROJECT BRIEF\n& SCOPE', ref, date, logo, cn, cc) +
    sec('1. Project Overview',
      '<table>' +
      '<tr><td width="34%"><b>Project Title</b></td><td>' + pn + '</td></tr>' +
      '<tr><td><b>Service Type</b></td><td>' + svc + '</td></tr>' +
      '<tr><td><b>Client</b></td><td>' + cn + ' — ' + cc + '</td></tr>' +
      '<tr><td><b>Contact</b></td><td>' + ce + '</td></tr>' +
      '<tr><td><b>Budget</b></td><td><span class="highlight">' + pv + '</span></td></tr>' +
      '<tr><td><b>Timeline</b></td><td>' + sd + ' → ' + ed + '</td></tr>' +
      '<tr><td><b>Payment</b></td><td>' + pt + '</td></tr>' +
      '<tr><td><b>Revisions</b></td><td>' + rv + '</td></tr></table>') +
    sec('2. Project Description & Scope',
      '<p>' + pd + '</p>' +
      '<div class="info-box">All deliverables are subject to the revision policy stated above. Any scope changes must be agreed in writing before implementation begins.</div>') +
    sec('3. Proposed Solution & Approach',
      '<p>' + BRAND.name + ' follows a structured, milestone-based delivery process:</p>' +
      '<ul><li><b>Discovery:</b> Requirements gathering, stakeholder interviews, and project planning.</li>' +
      '<li><b>Design:</b> Wireframes, mockups, and client approval before development begins.</li>' +
      '<li><b>Development / Execution:</b> Core deliverable build with regular progress updates.</li>' +
      '<li><b>Review & Revisions:</b> ' + rv + ' included at no extra charge.</li>' +
      '<li><b>Final Delivery:</b> Handover, documentation, and sign-off.</li></ul>') +
    sec('4. Project Milestones',
      '<table><tr><th>#</th><th>Phase</th><th>Deliverable</th><th>Target Date</th></tr>' +
      '<tr><td>1</td><td>Kickoff & Discovery</td><td>Requirements finalization, project plan</td><td>' + sd + '</td></tr>' +
      '<tr><td>2</td><td>Design & Wireframes</td><td>Mockups, prototypes & client approval</td><td>Week 1–2</td></tr>' +
      '<tr><td>3</td><td>Development / Execution</td><td>Core deliverable build</td><td>Week 2–4</td></tr>' +
      '<tr><td>4</td><td>Review & Revisions</td><td>' + rv + '</td><td>Week 4–5</td></tr>' +
      '<tr><td>5</td><td>Final Delivery</td><td>Handover, documentation & sign-off</td><td>' + ed + '</td></tr></table>') +
    sec('5. Acceptance Criteria',
      '<p>The project will be considered complete when:</p>' +
      '<ul><li>All deliverables listed in the scope have been provided.</li>' +
      '<li>Client has reviewed and approved the final output in writing.</li>' +
      '<li>All revision rounds have been completed or waived.</li>' +
      '<li>Final payment has been received in full.</li></ul>') +
    s;

  if (type === 'confidential') return buildHeader('Legal', 'CONFIDENTIALITY\nAGREEMENT', ref, date, logo, cn, cc) +
    sec('1. Parties',
      '<table><tr><th>Party</th><th>Name</th><th>Organization</th><th>Location</th></tr>' +
      '<tr><td><b>Party A (Disclosing)</b></td><td>' + BRAND.person + '</td><td>' + BRAND.name + '™</td><td>' + BRAND.address + '</td></tr>' +
      '<tr><td><b>Party B (Receiving)</b></td><td>' + cn + '</td><td>' + cc + '</td><td>' + f(fd.clientCity, 'Client City') + '</td></tr></table>') +
    sec('2. Purpose',
      '<p>This Confidentiality Agreement ("Agreement") is entered into as of <b>' + date + '</b> in connection with: <b>' + pn + '</b>. Both parties may share confidential information for the sole purpose of evaluating and executing this engagement. This Agreement is intended to protect the legitimate business interests of both parties.</p>') +
    sec('3. Definition of Confidential Information',
      '<p>Confidential Information includes, but is not limited to: all non-public business data, technical specifications, source code, algorithms, pricing structures, client lists, business strategies, financial information, and any other information marked as confidential or that a reasonable person would consider confidential given the nature of the disclosure.</p>' +
      '<p>Confidential Information does NOT include information that: (a) is or becomes publicly known through no breach of this Agreement; (b) was rightfully known before disclosure; (c) is independently developed without use of Confidential Information; or (d) is required to be disclosed by law.</p>') +
    sec('4. Obligations of the Receiving Party',
      termBlock('4.1', 'Non-Disclosure', 'The Receiving Party agrees not to disclose, publish, or share any Confidential Information with any third party without prior written consent from the Disclosing Party.') +
      termBlock('4.2', 'Limited Use', 'The Receiving Party shall use Confidential Information solely for the purpose stated above and shall not use it for any competitive or commercial advantage.') +
      termBlock('4.3', 'Protection', 'The Receiving Party shall protect Confidential Information with at least the same degree of care used to protect its own confidential information, but no less than reasonable care.') +
      termBlock('4.4', 'Duration', 'This Agreement remains in full force and effect for a period of <b>2 years</b> from the date of signing, and survives termination of any related engagement.') +
      termBlock('4.5', 'Return of Information', 'Upon request or termination, the Receiving Party shall promptly return or destroy all Confidential Information and certify such destruction in writing.')) +
    sec('5. Remedies',
      '<p>Both parties acknowledge that any breach of this Agreement may cause irreparable harm for which monetary damages would be inadequate. Accordingly, the Disclosing Party shall be entitled to seek equitable relief, including injunction, in addition to all other remedies available at law.</p>') +
    s;

  if (type === 'onboarding') return buildHeader(svc, 'CLIENT ONBOARDING\nDOCUMENT', ref, date, logo, cn, cc) +
    sec('Welcome, ' + cn + '!',
      '<p>Thank you for choosing <b>' + BRAND.name + '™</b> for <b>' + pn + '</b>. I am <b>' + BRAND.person + '</b>, Founder of ' + BRAND.name + '. I am committed to delivering exceptional results and maintaining transparent communication throughout our engagement.</p>' +
      '<div class="info-box">This document outlines how we will work together, what to expect at each stage, and how to get the best results from our collaboration.</div>') +
    sec('1. Project Summary',
      '<table>' +
      '<tr><td width="34%"><b>Project</b></td><td>' + pn + '</td></tr>' +
      '<tr><td><b>Service Type</b></td><td>' + svc + '</td></tr>' +
      '<tr><td><b>Contract Value</b></td><td><span class="highlight">' + pv + '</span></td></tr>' +
      '<tr><td><b>Timeline</b></td><td>' + sd + ' → ' + ed + '</td></tr>' +
      '<tr><td><b>Payment Schedule</b></td><td>' + pt + '</td></tr>' +
      '<tr><td><b>Revisions Included</b></td><td>' + rv + '</td></tr></table>') +
    sec('2. How We Work',
      '<p><b>Communication:</b> All project communication via email at <b>' + BRAND.email + '</b>. Response time: within 24 hours on business days.</p>' +
      '<p><b>Updates:</b> You will receive progress updates at each milestone. Major decisions require your written approval before proceeding.</p>' +
      '<p><b>Revisions:</b> ' + rv + ' are included. Please consolidate all feedback into a single revision request per round to avoid delays.</p>' +
      '<p><b>Payments:</b> Invoices are sent as per the agreed schedule. Please ensure timely payment to avoid project delays.</p>' +
      '<p><b>Files & Assets:</b> Please provide all required assets (logos, content, images) within 3 business days of project kickoff.</p>') +
    sec('3. Project Phases',
      '<table><tr><th>Phase</th><th>What Happens</th><th>Your Role</th></tr>' +
      '<tr><td><b>Kickoff</b></td><td>Requirements gathering, planning, asset collection</td><td>Provide brief, assets, and approvals</td></tr>' +
      '<tr><td><b>Design / Draft</b></td><td>Initial deliverable creation</td><td>Review and provide consolidated feedback</td></tr>' +
      '<tr><td><b>Revisions</b></td><td>' + rv + ' included</td><td>Approve or request changes</td></tr>' +
      '<tr><td><b>Final Delivery</b></td><td>Handover of all files and documentation</td><td>Final approval and payment</td></tr>' +
      '<tr><td><b>Support</b></td><td>7–14 days post-delivery support</td><td>Report any issues promptly</td></tr></table>') +
    sec('4. Important Policies',
      termBlock('4.1', 'Scope Changes', 'Any work outside the agreed scope will require a written change request and may incur additional charges.') +
      termBlock('4.2', 'Delays', 'If you are unable to provide required assets or approvals on time, the project timeline will be adjusted accordingly.') +
      termBlock('4.3', 'Confidentiality', 'All information shared between both parties will be kept strictly confidential.'));

  if (type === 'invoice-doc') {
    var r1 = (parseFloat(fd.rate1)||0)*(parseFloat(fd.qty1)||1);
    var r2 = (parseFloat(fd.rate2)||0)*(parseFloat(fd.qty2)||1);
    var isub = r1+r2, idisc = isub*(parseFloat(fd.discount)||0)/100, igrand = isub-idisc;
    return buildHeader('Invoice', 'INVOICE', f(fd.invoiceNum,'INV-2026-041'), date, logo, cn, cc,
      '<br/>Due: <b>' + f(fd.dueDate,'15 days') + '</b>') +
      sec('Line Items',
        '<table><tr><th>#</th><th>Description</th><th>Qty</th><th>Unit Rate</th><th>Amount</th></tr>' +
        '<tr><td>1</td><td>' + f(fd.item1,'Service 1') + '</td><td>' + (fd.qty1||1) + '</td><td>' + fm((parseFloat(fd.rate1)||0)) + '</td><td><b>' + fm(r1) + '</b></td></tr>' +
        '<tr><td>2</td><td>' + f(fd.item2,'Service 2') + '</td><td>' + (fd.qty2||1) + '</td><td>' + fm((parseFloat(fd.rate2)||0)) + '</td><td><b>' + fm(r2) + '</b></td></tr></table>') +
      '<div style="margin-left:auto;width:300px;font-size:11.5px;margin-top:12px;border:1px solid #d0d7e8;border-radius:4px;overflow:hidden">' +
      '<div style="display:flex;justify-content:space-between;padding:8px 14px;border-bottom:1px solid #d0d7e8;background:#f4f6fb"><span style="color:#555">Subtotal</span><span>' + fm(isub) + '</span></div>' +
      '<div style="display:flex;justify-content:space-between;padding:8px 14px;border-bottom:1px solid #d0d7e8;background:#f4f6fb"><span style="color:#c0392b">Discount (' + (fd.discount||0) + '%)</span><span style="color:#c0392b">− ' + fm(idisc) + '</span></div>' +
      '<div style="display:flex;justify-content:space-between;padding:10px 14px;font-weight:900;font-size:14px;background:#1a2744;color:#fff"><span>Grand Total</span><span>' + fm(igrand) + '</span></div></div>' +
      sec('Payment Instructions',
        '<p>Please transfer the amount to: <b>' + BRAND.email + '</b> (UPI / Bank Transfer). Reference your invoice number <b>' + f(fd.invoiceNum,'INV-2026-041') + '</b> in the payment description. Terms: <b>' + pt + '</b>.</p>') +
      '</div>';
  }

  if (type === 'proposal') return buildHeader(svc, 'SERVICE PROPOSAL\n& QUOTATION', ref, date, logo, cn, cc,
    '<br/>Valid Until: <b>' + (ed !== '___________' ? ed : '30 days from date') + '</b>') +
    sec('1. Executive Summary',
      '<p>Thank you for the opportunity to submit this proposal. <b>' + BRAND.name + '™</b> is pleased to present this service proposal for <b>' + pn + '</b>. We have carefully reviewed your requirements and are confident in our ability to deliver a high-quality solution that meets your business objectives on time and within budget.</p>' +
      '<div class="info-box">' + pd + '</div>') +
    sec('2. Proposed Solution & Approach',
      '<p><b>Our Approach:</b> ' + BRAND.name + ' follows an Agile-inspired delivery methodology, ensuring transparency, regular deliverables, and flexibility to adapt to changing requirements. Key elements of our approach:</p>' +
      '<ul><li><b>Discovery-first:</b> We invest time understanding your business before writing a single line of code.</li>' +
      '<li><b>Iterative delivery:</b> Regular milestone demos so you see progress at every stage.</li>' +
      '<li><b>Quality-first:</b> Dedicated review at every phase, not just at the end.</li>' +
      '<li><b>Post-launch support:</b> We do not disappear after go-live — ' + rv + ' included.</li></ul>') +
    sec('3. Scope of Services & Pricing',
      '<table><tr><th>#</th><th>Service / Deliverable</th><th>Description</th><th>Qty</th><th>Unit</th><th>Rate (INR)</th><th>Total (INR)</th></tr>' +
      '<tr><td>1</td><td><b>' + svc + '</b></td><td>' + pd + '</td><td>1</td><td>Project</td><td>' + pv + '</td><td><b>' + pv + '</b></td></tr></table>' +
      '<div style="margin-left:auto;width:280px;margin-top:10px;border:1px solid #d0d7e8;border-radius:4px;overflow:hidden;font-size:11px">' +
      '<div style="display:flex;justify-content:space-between;padding:7px 12px;background:#f4f6fb;border-bottom:1px solid #d0d7e8"><span>Subtotal</span><span>' + pv + '</span></div>' +
      '<div style="display:flex;justify-content:space-between;padding:9px 12px;font-weight:900;font-size:13px;background:#1a2744;color:#fff"><span>Total Investment</span><span>' + pv + '</span></div></div>') +
    sec('4. Timeline & Payment',
      '<table>' +
      '<tr><td width="34%"><b>Proposed Start</b></td><td>' + sd + '</td></tr>' +
      '<tr><td><b>Proposed Delivery</b></td><td>' + ed + '</td></tr>' +
      '<tr><td><b>Payment Terms</b></td><td>' + pt + '</td></tr>' +
      '<tr><td><b>Revisions Included</b></td><td>' + rv + '</td></tr>' +
      '<tr><td><b>Proposal Valid Until</b></td><td>' + (ed !== '___________' ? ed : '30 days from date') + '</td></tr></table>') +
    sec('5. Why LathiNyx DevLabs?',
      '<ul><li><b>Proven Expertise:</b> Hands-on experience across web development, AI/ML, and academic research services.</li>' +
      '<li><b>On-Time Delivery:</b> Structured milestone-based approach ensures timely completion.</li>' +
      '<li><b>Transparent Communication:</b> Regular updates, clear documentation, and responsive support.</li>' +
      '<li><b>Post-Delivery Support:</b> Dedicated support period after project handover.</li>' +
      '<li><b>Flexible Engagement:</b> Fixed-price, milestone-based, or retainer models available.</li></ul>') +
    sec('6. Next Steps',
      '<p>To proceed with this proposal, please:</p>' +
      '<ul><li>Review and sign this document.</li><li>Make the advance payment as per the agreed schedule.</li><li>Share all required assets and access credentials.</li><li>Schedule a kickoff call at your earliest convenience.</li></ul>' +
      '<p>We look forward to working with you. Please contact us at <b>' + BRAND.email + '</b> with any questions.</p>') +
    s;

  if (type === 'testimonial') return buildHeader(svc, 'TESTIMONIAL\nREQUEST FORM', ref, date, logo, cn, cc) +
    sec('1. Parties',
      '<table><tr><th>Role</th><th>Full Name</th><th>Organization</th><th>Contact</th></tr>' +
      '<tr><td><b>Service Provider</b></td><td>' + BRAND.person + '</td><td>' + BRAND.name + '™</td><td>' + BRAND.email + '</td></tr>' +
      '<tr><td><b>Client</b></td><td>' + cn + '</td><td>' + cc + '</td><td>' + ce + '</td></tr></table>') +
    sec('2. Project Summary',
      '<table>' +
      '<tr><td width="34%"><b>Project Name</b></td><td>' + pn + '</td></tr>' +
      '<tr><td><b>Service Type</b></td><td>' + svc + '</td></tr>' +
      '<tr><td><b>Project Value</b></td><td><span class="highlight">' + pv + '</span></td></tr>' +
      '<tr><td><b>Timeline</b></td><td>' + sd + ' → ' + ed + '</td></tr></table>') +
    sec('3. Feedback Request',
      '<p>We would be grateful if you could share your experience working with <b>' + BRAND.name + '™</b> on this project. Your honest feedback helps us improve our services and helps other clients make informed decisions.</p>' +
      '<p>Please consider sharing your thoughts on:</p>' +
      '<ul><li>Quality of the deliverables</li><li>Communication and responsiveness</li><li>Adherence to timeline and budget</li><li>Overall experience working with ' + BRAND.name + '</li><li>Would you recommend us to others?</li></ul>') +
    sec('4. Rating',
      '<table><tr><th>Category</th><th>Rating (1–5)</th><th>Comments</th></tr>' +
      '<tr><td>Quality of Work</td><td>&nbsp;</td><td>&nbsp;</td></tr>' +
      '<tr><td>Communication</td><td>&nbsp;</td><td>&nbsp;</td></tr>' +
      '<tr><td>Timeline</td><td>&nbsp;</td><td>&nbsp;</td></tr>' +
      '<tr><td>Value for Money</td><td>&nbsp;</td><td>&nbsp;</td></tr>' +
      '<tr><td>Overall</td><td>&nbsp;</td><td>&nbsp;</td></tr></table>') +
    sec('5. Permission to Publish',
      '<p>By signing below, you grant <b>' + BRAND.name + '™</b> permission to publish your testimonial (in full or edited form) on our website, social media, and marketing materials. Your name and company may be included unless you request anonymity.</p>') +
    s;

  if (type === 'retainer') return buildHeader(svc, 'RETAINER\nAGREEMENT', ref, date, logo, cn, cc) +
    sec('1. Parties',
      '<table><tr><th>Role</th><th>Full Name</th><th>Organization</th><th>Contact</th></tr>' +
      '<tr><td><b>Service Provider</b></td><td>' + BRAND.person + '</td><td>' + BRAND.name + '™</td><td>' + BRAND.email + '</td></tr>' +
      '<tr><td><b>Client</b></td><td>' + cn + '</td><td>' + cc + '</td><td>' + ce + '</td></tr></table>') +
    sec('2. Retainer Details',
      '<table>' +
      '<tr><td width="34%"><b>Service Type</b></td><td>' + svc + '</td></tr>' +
      '<tr><td><b>Monthly Scope</b></td><td>' + pd + '</td></tr>' +
      '<tr><td><b>Monthly Rate</b></td><td><span class="highlight">' + pv + '</span></td></tr>' +
      '<tr><td><b>Billing Cycle</b></td><td>Monthly, on the 1st of each month</td></tr>' +
      '<tr><td><b>Start Date</b></td><td>' + sd + '</td></tr>' +
      '<tr><td><b>Notice Period</b></td><td>30 days written notice</td></tr>' +
      '<tr><td><b>Payment Terms</b></td><td>' + pt + '</td></tr></table>') +
    sec('3. Scope of Monthly Services',
      '<p>The following services are included in the monthly retainer:</p>' +
      '<ul><li>' + pd + '</li>' +
      '<li>Regular progress updates and communication</li>' +
      '<li>Priority support and response within 24 hours on business days</li>' +
      '<li>Monthly summary report of work completed</li></ul>' +
      '<div class="info-box">Any work outside the agreed monthly scope will require a written change request and will be billed separately at the standard rate.</div>') +
    sec('4. Terms & Conditions',
      termBlock('4.1', 'Monthly Payment', 'Payment is due on the 1st of each month for the upcoming month\'s services. Late payments attract a fee of <b>2% per month</b> on the outstanding amount. Services may be paused if payment is overdue by more than 7 days.') +
      termBlock('4.2', 'Scope', 'Work is limited to the monthly scope described above. Any additional work outside the agreed scope will be billed separately at the standard rate, with prior written approval.') +
      termBlock('4.3', 'Termination', 'Either party may terminate this agreement with <b>30 days written notice</b>. A pro-rated final invoice will be issued for any work completed in the notice period.') +
      termBlock('4.4', 'Intellectual Property', 'All work product and deliverables created under this agreement become the property of the Client upon receipt of full payment for that month.') +
      termBlock('4.5', 'Confidentiality', 'Both parties agree to keep all shared information strictly confidential for the duration of this agreement and for 2 years thereafter.')) +
    s;

  return buildHeader('Document', pn.toUpperCase(), ref, date, logo, cn, cc) +
    sec('Details', '<p>' + pd + '</p>') + '</div>';
}

function openPDF(type, fd, sig) {
  var ref = 'LATHINYX-' + Math.floor(Math.random()*9000+1000);
  var date = new Date().toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' });
  var body = buildBody(type, fd, ref, date, sig, logoImg);
  var footer = '<footer><span><b>' + BRAND.name + '™</b> &nbsp;·&nbsp; ' + BRAND.website + ' &nbsp;·&nbsp; ' + BRAND.email + '</span><span>Ref: <b>' + ref + '</b></span></footer>';
  var html = '<!DOCTYPE html><html><head><title>Document</title><style>' + PDF_CSS + '</style></head><body>' + body + footer + '<script>window.onload=function(){window.print();}<\/script></body></html>';
  var w = window.open('', '_blank'); w.document.write(html); w.document.close();
}

function downloadTxt(type, fd) {
  var ref = 'LATHINYX-' + Math.floor(Math.random()*9000+1000);
  var content = BRAND.name + '\n' + BRAND.email + '\n' + BRAND.website + '\n\n' +
    type.toUpperCase() + ' | Ref: ' + ref + '\n\nClient: ' + (fd.clientName||'') +
    '\nProject: ' + (fd.projectName||'') + '\nValue: ' + (fd.projectValue ? 'Rs.'+fd.projectValue : '');
  var a = document.createElement('a');
  a.href = URL.createObjectURL(new Blob([content], { type: 'text/plain' }));
  a.download = 'LathiNyx_' + type + '_' + ref + '.txt'; a.click();
}

function downloadWord(type, fd) {
  var ref = 'LATHINYX-' + Math.floor(Math.random()*9000+1000);
  var rtf = '{\\rtf1\\ansi\\deff0\n{\\fonttbl{\\f0\\froman Times New Roman;}{\\f1\\fswiss Arial;}}\n\\paperw11906\\paperh16838\\margl1440\\margr1440\\margt1440\\margb1440\n{\\f1\\fs32\\b ' + BRAND.name + '\\par}\n{\\f1\\fs18 ' + BRAND.email + '\\par}\n\\line\n{\\f1\\fs26\\b ' + type.toUpperCase() + '\\par}\n{\\f0\\fs22 Client: ' + (fd.clientName||'') + '\\par}\n{\\f0\\fs22 Project: ' + (fd.projectName||'') + '\\par}\n}';
  var a = document.createElement('a');
  a.href = URL.createObjectURL(new Blob([rtf], { type: 'application/rtf' }));
  a.download = 'LathiNyx_' + type + '_' + ref + '.rtf'; a.click();
}

const formFields = {
  contract: [
    { section: 'Client Details' },
    { id: 'clientName', label: 'Client Name', type: 'text', placeholder: 'e.g. Rahul Sharma' },
    { id: 'clientCompany', label: 'Company / Organization', type: 'text', placeholder: 'e.g. TechCorp Pvt Ltd' },
    { id: 'clientEmail', label: 'Client Email', type: 'email', placeholder: 'client@company.com' },
    { id: 'clientCity', label: 'Client City', type: 'text', placeholder: 'e.g. Mumbai' },
    { section: 'Service & Project Details' },
    { id: 'serviceType', label: 'Type of Service', type: 'select' },
    { id: 'projectName', label: 'Project Name', type: 'text', placeholder: 'e.g. E-commerce Website' },
    { id: 'projectDesc', label: 'Project Description / Scope', type: 'richtext', placeholder: 'Describe the project scope, deliverables, and requirements...' },
    { id: 'projectValue', label: 'Total Contract Value (Rs.)', type: 'number', placeholder: '45000' },
    { id: 'paymentTerms', label: 'Payment Terms', type: 'text', placeholder: '50% advance, 50% on delivery' },
    { id: 'revisions', label: 'Revision Policy', type: 'text', placeholder: '3 free revision rounds' },
    { id: 'startDate', label: 'Start Date', type: 'date' },
    { id: 'endDate', label: 'Deadline', type: 'date' },
  ],
  project: [
    { section: 'Client Details' },
    { id: 'clientName', label: 'Client Name', type: 'text', placeholder: 'Client Name' },
    { id: 'clientCompany', label: 'Company', type: 'text', placeholder: 'Company Name' },
    { id: 'clientEmail', label: 'Client Email', type: 'email', placeholder: 'client@email.com' },
    { section: 'Project Details' },
    { id: 'serviceType', label: 'Type of Service', type: 'select' },
    { id: 'projectName', label: 'Project Name', type: 'text', placeholder: 'Project Name' },
    { id: 'projectDesc', label: 'Description / Scope', type: 'richtext', placeholder: 'Describe the project scope...' },
    { id: 'projectValue', label: 'Budget (Rs.)', type: 'number', placeholder: '45000' },
    { id: 'paymentTerms', label: 'Payment Terms', type: 'text', placeholder: '50% advance, 50% on delivery' },
    { id: 'revisions', label: 'Revisions', type: 'text', placeholder: '3 free rounds' },
    { id: 'startDate', label: 'Start Date', type: 'date' },
    { id: 'endDate', label: 'Deadline', type: 'date' },
  ],
  confidential: [
    { section: 'Client (Party B)' },
    { id: 'clientName', label: 'Client Name', type: 'text', placeholder: 'Client Name' },
    { id: 'clientCompany', label: 'Company', type: 'text', placeholder: 'Company Name' },
    { id: 'clientCity', label: 'City', type: 'text', placeholder: 'City' },
    { section: 'Purpose' },
    { id: 'serviceType', label: 'Type of Service', type: 'select' },
    { id: 'projectName', label: 'Purpose / Project', type: 'text', placeholder: 'e.g. Web Development Project' },
    { id: 'projectDesc', label: 'Additional Details', type: 'richtext', placeholder: 'Any additional context...' },
  ],
  onboarding: [
    { section: 'Client Details' },
    { id: 'clientName', label: 'Client Name', type: 'text', placeholder: 'Client Name' },
    { id: 'clientCompany', label: 'Company', type: 'text', placeholder: 'Company Name' },
    { section: 'Project' },
    { id: 'serviceType', label: 'Type of Service', type: 'select' },
    { id: 'projectName', label: 'Project Name', type: 'text', placeholder: 'Project Name' },
    { id: 'projectDesc', label: 'Project Overview', type: 'richtext', placeholder: 'Brief project overview...' },
    { id: 'projectValue', label: 'Project Value (Rs.)', type: 'number', placeholder: '45000' },
    { id: 'paymentTerms', label: 'Payment Terms', type: 'text', placeholder: '50% advance, 50% on delivery' },
    { id: 'revisions', label: 'Revisions', type: 'text', placeholder: '3 free rounds' },
    { id: 'startDate', label: 'Start Date', type: 'date' },
    { id: 'endDate', label: 'Delivery Date', type: 'date' },
  ],
  'invoice-doc': [
    { section: 'Bill To' },
    { id: 'clientName', label: 'Client Name', type: 'text', placeholder: 'Client Name' },
    { id: 'clientCompany', label: 'Company', type: 'text', placeholder: 'Company Name' },
    { id: 'clientEmail', label: 'Client Email', type: 'email', placeholder: 'client@email.com' },
    { section: 'Invoice Details' },
    { id: 'serviceType', label: 'Type of Service', type: 'select' },
    { id: 'invoiceNum', label: 'Invoice Number', type: 'text', placeholder: 'INV-2026-041' },
    { id: 'dueDate', label: 'Due Date', type: 'date' },
    { id: 'paymentTerms', label: 'Payment Terms', type: 'text', placeholder: 'Net 15 days' },
    { section: 'Line Items' },
    { id: 'item1', label: 'Item 1 Description', type: 'text', placeholder: 'Web Design & Development' },
    { id: 'qty1', label: 'Qty 1', type: 'number', placeholder: '1' },
    { id: 'rate1', label: 'Rate 1 (Rs.)', type: 'number', placeholder: '40000' },
    { id: 'item2', label: 'Item 2 Description', type: 'text', placeholder: 'SEO & Mobile Optimization' },
    { id: 'qty2', label: 'Qty 2', type: 'number', placeholder: '1' },
    { id: 'rate2', label: 'Rate 2 (Rs.)', type: 'number', placeholder: '8000' },
    { id: 'discount', label: 'Discount (%)', type: 'number', placeholder: '10' },
  ],
  proposal: [
    { section: 'Client Details' },
    { id: 'clientName', label: 'Client Name', type: 'text', placeholder: 'Client Name' },
    { id: 'clientCompany', label: 'Company', type: 'text', placeholder: 'Company Name' },
    { id: 'clientEmail', label: 'Client Email', type: 'email', placeholder: 'client@email.com' },
    { section: 'Proposal Details' },
    { id: 'serviceType', label: 'Type of Service', type: 'select' },
    { id: 'projectName', label: 'Project / Proposal Title', type: 'text', placeholder: 'e.g. E-commerce Website Development' },
    { id: 'projectDesc', label: 'Client Need / Problem Statement', type: 'richtext', placeholder: 'Describe what the client needs...' },
    { id: 'projectValue', label: 'Proposed Budget (Rs.)', type: 'number', placeholder: '45000' },
    { id: 'paymentTerms', label: 'Payment Terms', type: 'text', placeholder: '50% advance, 50% on delivery' },
    { id: 'revisions', label: 'Revisions', type: 'text', placeholder: '3 free rounds' },
    { id: 'startDate', label: 'Proposed Start', type: 'date' },
    { id: 'endDate', label: 'Proposed Delivery', type: 'date' },
  ],
  testimonial: [
    { section: 'Client Details' },
    { id: 'clientName', label: 'Client Name', type: 'text', placeholder: 'Client Name' },
    { id: 'clientCompany', label: 'Company', type: 'text', placeholder: 'Company Name' },
    { id: 'clientEmail', label: 'Client Email', type: 'email', placeholder: 'client@email.com' },
    { section: 'Project Details' },
    { id: 'serviceType', label: 'Type of Service', type: 'select' },
    { id: 'projectName', label: 'Project Name', type: 'text', placeholder: 'Project Name' },
    { id: 'projectValue', label: 'Project Value (Rs.)', type: 'number', placeholder: '45000' },
    { id: 'startDate', label: 'Start Date', type: 'date' },
    { id: 'endDate', label: 'End Date', type: 'date' },
  ],
  retainer: [
    { section: 'Client Details' },
    { id: 'clientName', label: 'Client Name', type: 'text', placeholder: 'Client Name' },
    { id: 'clientCompany', label: 'Company', type: 'text', placeholder: 'Company Name' },
    { id: 'clientEmail', label: 'Client Email', type: 'email', placeholder: 'client@email.com' },
    { section: 'Retainer Details' },
    { id: 'serviceType', label: 'Type of Service', type: 'select' },
    { id: 'projectName', label: 'Monthly Scope / Services', type: 'text', placeholder: 'e.g. Ongoing Web Maintenance' },
    { id: 'projectDesc', label: 'Scope Details', type: 'richtext', placeholder: 'Describe the monthly scope of work...' },
    { id: 'projectValue', label: 'Monthly Rate (Rs.)', type: 'number', placeholder: '15000' },
    { id: 'startDate', label: 'Retainer Start Date', type: 'date' },
    { id: 'paymentTerms', label: 'Payment Terms', type: 'text', placeholder: 'Monthly, on the 1st' },
  ],
}; 
// Rich text toolbar for description fields
function RichTextArea({ value, onChange, placeholder }) {
  const ref = useRef(null);

  const applyFormat = (type) => {
    const ta = ref.current;
    const start = ta.selectionStart, end = ta.selectionEnd;
    const sel = value.substring(start, end);
    const before = value.substring(0, start), after = value.substring(end);
    let insert = sel;
    if (type === 'bold') insert = '**' + (sel || 'bold text') + '**';
    else if (type === 'bullet') {
      const lines = (sel || 'Item').split('\n').map(l => '• ' + l.trim()).join('\n');
      insert = lines;
    } else if (type === 'numbered') {
      const lines = (sel || 'Item').split('\n').map((l, i) => (i+1) + '. ' + l.trim()).join('\n');
      insert = lines;
    } else if (type === 'alpha') {
      const lines = (sel || 'Item').split('\n').map((l, i) => String.fromCharCode(97+i) + ') ' + l.trim()).join('\n');
      insert = lines;
    }
    const newVal = before + insert + after;
    onChange(newVal);
    setTimeout(() => { ta.focus(); ta.setSelectionRange(start, start + insert.length); }, 0);
  };

  return (
    <div>
      <div style={{ display: 'flex', gap: 4, marginBottom: 6, flexWrap: 'wrap' }}>
        {[
          { label: 'B', title: 'Bold', type: 'bold', style: { fontWeight: 900 } },
          { label: '• List', title: 'Bullet points', type: 'bullet' },
          { label: '1. List', title: 'Numbered list', type: 'numbered' },
          { label: 'a) List', title: 'Alphabetical list', type: 'alpha' },
        ].map(btn => (
          <button key={btn.type} type="button" title={btn.title}
            onClick={() => applyFormat(btn.type)}
            style={{ padding: '3px 10px', fontSize: 11, border: '1px solid #e0dff0', borderRadius: 6, background: '#f8f8ff', cursor: 'pointer', color: '#1800ad', fontWeight: 600, ...btn.style }}>
            {btn.label}
          </button>
        ))}
        <span style={{ fontSize: 10, color: '#aaa', alignSelf: 'center', marginLeft: 4 }}>Select text then click, or click to insert</span>
      </div>
      <textarea
        ref={ref}
        className="d-finput"
        rows={5}
        placeholder={placeholder || ''}
        value={value || ''}
        onChange={e => onChange(e.target.value)}
        style={{ fontFamily: 'monospace', fontSize: 12 }}
      />
    </div>
  );
}

export default function Contracts() {
  const [filter, setFilter] = useState('all');
  const [editDoc, setEditDoc] = useState(null);
  const [formData, setFormData] = useState({ ...defaultForm });
  const [signature, setSignature] = useState(null);
  const [clientSearch, setClientSearch] = useState('');
  const [showClientList, setShowClientList] = useState(false);
  const signRef = useRef(null);
  const savedClients = loadSavedClients();
  const filteredDocs = docs.filter(d => filter === 'all' || d.type === filter);
  const openEdit = (doc) => { setFormData({ ...defaultForm }); setClientSearch(''); setEditDoc(doc); };
  const closeEdit = () => { setEditDoc(null); setShowClientList(false); };
  const setField = (id, val) => setFormData(prev => ({ ...prev, [id]: val }));
  const fields = editDoc ? (formFields[editDoc.type] || formFields.contract) : [];
  const sub = (parseFloat(formData.rate1)||0)*(parseFloat(formData.qty1)||1) + (parseFloat(formData.rate2)||0)*(parseFloat(formData.qty2)||1);
  const disc = sub*(parseFloat(formData.discount)||0)/100;
  const grand = sub - disc;
  const fmt = n => 'Rs.' + Math.round(n).toLocaleString('en-IN');

  const filteredClients = savedClients.filter(c =>
    clientSearch.length > 0 && (
      c.name.toLowerCase().includes(clientSearch.toLowerCase()) ||
      (c.company||'').toLowerCase().includes(clientSearch.toLowerCase())
    )
  );

  const selectClient = (c) => {
    const latestInvoice = c.invoices && c.invoices.length > 0 ? c.invoices[0] : null;
    setFormData(prev => ({
      ...prev,
      clientName: c.name||'', clientCompany: c.company||'', clientEmail: c.email||'', clientCity: c.city||'',
      ...(latestInvoice ? { invoiceNum: latestInvoice.num||prev.invoiceNum, projectValue: latestInvoice.amount||prev.projectValue } : {}),
    }));
    setClientSearch(c.name);
    setShowClientList(false);
  };

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <div style={{ fontSize: 17, fontWeight: 800, color: '#1a1a1a' }}>📑 Contracts & Project Documents</div>
        <div style={{ fontSize: 13, color: '#555', marginTop: 4 }}>Fill in client details, then preview and download with LathiNyx DevLabs letterhead</div>
      </div>

      <div className="d-card" style={{ marginBottom: 16 }}>
        <div className="d-ctitle">✍️ Your Digital Signature <span className="d-badge">Used on all documents</span></div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 20, flexWrap: 'wrap' }}>
          <div className="d-sign-upload" style={{ minWidth: 200, flex: 1 }} onClick={() => signRef.current.click()}>
            {signature ? <img src={signature} alt="Signature" className="d-sign-preview" />
              : <><div style={{ fontSize: 24 }}>✍️</div><p>Click to upload signature</p><p style={{ fontSize: 12, color: '#aaa' }}>PNG preferred</p></>}
          </div>
          <input ref={signRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={e => {
            const file = e.target.files[0]; if (!file) return;
            const reader = new FileReader(); reader.onload = ev => setSignature(ev.target.result); reader.readAsDataURL(file);
          }} />
          <div style={{ fontSize: 13, color: '#555' }}>
            Upload once — appears on all generated PDFs.
            {signature && <div style={{ marginTop: 8, display: 'flex', gap: 6 }}>
              <button className="d-btn d-btn-sm d-btn-primary" onClick={() => signRef.current.click()}>🔄 Replace</button>
              <button className="d-btn d-btn-sm d-btn-danger" onClick={() => setSignature(null)}>✕ Remove</button>
            </div>}
          </div>
        </div>
      </div>

      <div className="d-doc-tabs">
        {[['all','All'],['contract','📝 Contracts'],['project','📋 Project Docs'],['confidential','🔒 Confidentiality']].map(([val, label]) => (
          <button key={val} className={`d-doc-tab${filter === val ? ' active' : ''}`} onClick={() => setFilter(val)}>{label}</button>
        ))}
      </div>

      <div style={{ display: 'grid', gap: 14 }}>
        {filteredDocs.map(doc => (
          <div key={doc.title} className="d-doc-card">
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16, marginBottom: 14 }}>
              <div className={`d-doc-icon ${doc.iconClass}`} style={{ fontSize: 24 }}>{doc.icon}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1a1a', marginBottom: 4 }}>{doc.title}</div>
                <div style={{ fontSize: 13, color: '#555', marginBottom: 6 }}>{doc.sub}</div>
                <div style={{ fontSize: 12, color: '#777' }}><b style={{ color: '#1800ad' }}>Covers:</b> {doc.covers}</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 4, alignItems: 'flex-end', flexShrink: 0 }}>
                <span className="d-doc-type-badge doc-type-pdf">📄 PDF</span>
                {doc.type !== 'invoice-doc' && <span className="d-doc-type-badge doc-type-word">📘 DOCX</span>}
                <span className="d-doc-type-badge" style={{ background: '#f4f4f0', color: '#555' }}>📃 TXT</span>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', paddingTop: 12, borderTop: '1px solid #f0f0ec' }}>
              <button className="d-btn d-btn-primary d-btn-sm" onClick={() => openEdit(doc)}>✏️ Edit & Fill Details</button>
              <button className="d-btn d-btn-sm" style={{ background: '#fff0f2', color: '#d63a55', borderColor: '#ffc5ce' }} onClick={() => openPDF(doc.type, defaultForm, signature)}>📄 Quick PDF</button>
              {doc.type !== 'invoice-doc' && <button className="d-btn d-btn-sm" style={{ background: '#eef0ff', color: '#1800ad', borderColor: '#c5caff' }} onClick={() => downloadWord(doc.type, defaultForm)}>📘 Word</button>}
              <button className="d-btn d-btn-sm" onClick={() => downloadTxt(doc.type, defaultForm)}>📃 TXT</button>
            </div>
          </div>
        ))}
      </div>

      {editDoc && (
        <div className="d-modal-overlay open" onClick={e => e.target === e.currentTarget && closeEdit()}>
          <div style={{ background: '#fff', borderRadius: 16, width: '94vw', maxWidth: 960, maxHeight: '96vh', display: 'flex', flexDirection: 'column', boxShadow: '0 24px 80px rgba(0,0,0,0.22)', overflow: 'hidden' }}>
            <div style={{ padding: '20px 28px 16px', borderBottom: '1px solid #e5e4f0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
              <div>
                <div style={{ fontSize: 18, fontWeight: 800, color: '#1a1a1a' }}>{editDoc.icon} {editDoc.title}</div>
                <div style={{ fontSize: 13, color: '#666', marginTop: 2 }}>Fill in the details below, then generate your document</div>
              </div>
              <span className="d-close-btn" onClick={closeEdit} style={{ fontSize: 28 }}>&times;</span>
            </div>

            <div style={{ flex: 1, overflowY: 'auto', padding: '24px 28px' }}>
              {/* Client Picker */}
              {savedClients.length > 0 && (
                <div style={{ marginBottom: 20, padding: '14px 16px', background: '#fff8fa', border: '1px solid #ffd6e0', borderRadius: 10 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: '#ff7c90', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.6px' }}>👤 Auto-fill from Saved Clients</div>
                  <div style={{ position: 'relative' }}>
                    <input className="d-finput" placeholder="Search client name or company..." value={clientSearch}
                      onChange={e => { setClientSearch(e.target.value); setShowClientList(true); }}
                      onFocus={() => setShowClientList(true)} style={{ width: '100%' }} />
                    {showClientList && filteredClients.length > 0 && (
                      <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '1px solid #ffd6e0', borderRadius: 8, boxShadow: '0 8px 24px rgba(0,0,0,0.12)', zIndex: 100, maxHeight: 200, overflowY: 'auto' }}>
                        {filteredClients.map(c => (
                          <div key={c.id} onClick={() => selectClient(c)}
                            style={{ padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid #fff0f4', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                            onMouseEnter={e => e.currentTarget.style.background = '#fff0f4'}
                            onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                            <div>
                              <div style={{ fontWeight: 700, fontSize: 13, color: '#1a1a1a' }}>{c.name}</div>
                              {c.company && <div style={{ fontSize: 11, color: '#888' }}>{c.company}</div>}
                            </div>
                            <div style={{ fontSize: 11, color: '#ff7c90', fontWeight: 600 }}>Select →</div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  {formData.clientName && (
                    <div style={{ marginTop: 8, fontSize: 12, color: '#4ecba0', fontWeight: 600 }}>
                      ✓ Filled: {formData.clientName}{formData.clientCompany ? ` · ${formData.clientCompany}` : ''}
                    </div>
                  )}
                </div>
              )}

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 28px' }}>
                {fields.map((field, i) => {
                  if (field.section) return (
                    <div key={i} style={{ gridColumn: '1/-1', fontSize: 12, fontWeight: 700, color: '#ff7c90', textTransform: 'uppercase', letterSpacing: '0.8px', margin: '20px 0 12px', paddingBottom: 6, borderBottom: '2px solid #fff0f4' }}>{field.section}</div>
                  );
                  if (field.type === 'select') return (
                    <div key={field.id} className="d-fg">
                      <div className="d-flabel">{field.label}</div>
                      <select className="d-finput" value={formData[field.id] || ''} onChange={e => setField(field.id, e.target.value)}>
                        {SERVICE_TYPES.map(s => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </div>
                  );
                  if (field.type === 'richtext') return (
                    <div key={field.id} className="d-fg" style={{ gridColumn: '1/-1' }}>
                      <div className="d-flabel">{field.label}</div>
                      <RichTextArea value={formData[field.id] || ''} onChange={val => setField(field.id, val)} placeholder={field.placeholder} />
                    </div>
                  );
                  if (field.type === 'textarea') return (
                    <div key={field.id} className="d-fg" style={{ gridColumn: '1/-1' }}>
                      <div className="d-flabel">{field.label}</div>
                      <textarea className="d-finput" rows={4} placeholder={field.placeholder || ''} value={formData[field.id] || ''} onChange={e => setField(field.id, e.target.value)} />
                    </div>
                  );
                  return (
                    <div key={field.id} className="d-fg">
                      <div className="d-flabel">{field.label}</div>
                      <input className="d-finput" type={field.type || 'text'} placeholder={field.placeholder || ''} value={formData[field.id] || ''} onChange={e => setField(field.id, e.target.value)} />
                    </div>
                  );
                })}
              </div>

              {editDoc.type === 'invoice-doc' && (
                <div style={{ background: '#fff8fa', padding: '16px 20px', borderRadius: 10, border: '1px solid #ffd6e0', marginTop: 20 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: '#1a1a1a', marginBottom: 10 }}>Invoice Total</div>
                  <div style={{ display: 'flex', gap: 32, flexWrap: 'wrap', fontSize: 14 }}>
                    <div><span style={{ color: '#555' }}>Subtotal: </span><b>{fmt(sub)}</b></div>
                    <div><span style={{ color: '#d63a55' }}>Discount ({formData.discount||0}%): </span><b style={{ color: '#d63a55' }}>-{fmt(disc)}</b></div>
                    <div><span style={{ fontWeight: 700 }}>Grand Total: </span><b style={{ color: '#ff7c90', fontSize: 16 }}>{fmt(grand)}</b></div>
                  </div>
                </div>
              )}

              <div style={{ marginTop: 24, background: '#f8f8ff', border: '1px solid #e5e4f0', borderRadius: 10, padding: '16px 20px' }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#1800ad', marginBottom: 12 }}>📋 Quick Preview</div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 8, fontSize: 13 }}>
                  {formData.clientName && <div><span style={{ color: '#666' }}>Client: </span><b>{formData.clientName}</b></div>}
                  {formData.serviceType && <div><span style={{ color: '#666' }}>Service: </span><b>{formData.serviceType}</b></div>}
                  {formData.projectName && <div><span style={{ color: '#666' }}>Project: </span><b>{formData.projectName}</b></div>}
                  {formData.projectValue && <div><span style={{ color: '#666' }}>Value: </span><b style={{ color: '#ff7c90' }}>{fmt(parseFloat(formData.projectValue)||0)}</b></div>}
                  {formData.startDate && <div><span style={{ color: '#666' }}>Start: </span><b>{formData.startDate}</b></div>}
                  {formData.endDate && <div><span style={{ color: '#666' }}>Deadline: </span><b>{formData.endDate}</b></div>}
                </div>
                {signature && <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px solid #e5e4f0', display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontSize: 12, color: '#666' }}>Signature:</span>
                  <img src={signature} alt="sig" style={{ maxHeight: 36, maxWidth: 120, objectFit: 'contain' }} />
                </div>}
              </div>
            </div>

            <div style={{ padding: '16px 28px', borderTop: '1px solid #e5e4f0', display: 'flex', gap: 10, flexWrap: 'wrap', flexShrink: 0, background: '#fafaf8' }}>
              <button className="d-btn d-btn-primary" onClick={() => openPDF(editDoc.type, formData, signature)}>📄 Generate PDF</button>
              {editDoc.type !== 'invoice-doc' && <button className="d-btn" style={{ background: '#eef0ff', color: '#1800ad', borderColor: '#c5caff' }} onClick={() => downloadWord(editDoc.type, formData)}>📘 Word / RTF</button>}
              <button className="d-btn" onClick={() => downloadTxt(editDoc.type, formData)}>📃 TXT</button>
              <button className="d-btn" style={{ marginLeft: 'auto' }} onClick={closeEdit}>✕ Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
